import { usePathname, useRouter } from 'next/navigation'
import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { ReactGAEvent } from '@/components/ReactGAs'

const Categories = ({ category, selectedCategory, setSelectedCategory, page = 0 }) => {
	const pathname = usePathname()
	const router = useRouter()

	useEffect(() => {
		const _CategoryFromPath = pathname.substring(pathname.lastIndexOf('/') + 1)
		if (_CategoryFromPath === 'products') {
			setSelectedCategory(category[0])
		} else {
			setSelectedCategory(category.find((item) => item.slug === _CategoryFromPath))
		}
	}, [pathname])

	const clickGAHandler = (category) => {
		ReactGAEvent({ action: 'Click', event: 'view_page', label: 'Blank', category })
	}

	return (
		<Row>
			<Col md={12}>
				<p className='banner-sub-heading'>Add any commodity you want to enquire about and get instant quotations.</p>
			</Col>
			<Col className='scroll-tab'>
				{category?.map((item, index) => {
					const _selectedCategory =
						selectedCategory?.name === item?.name && page === 1 ? 'scroll-selected-tab btn-primary' : 'scroll-disabled-tab text-dark'
					return (
						<button
							className={`${_selectedCategory} cursor-pointer border-0 `}
							disabled={page !== 1}
							size='sm'
							key={`category-${index}`}
							onClick={() => {
								if (index === 0) {
									if (selectedCategory?.commodity_id !== 0) {
										clickGAHandler('all')
										setSelectedCategory(item)
										router.push('/products')
									}
								} else {
									clickGAHandler(item?.name)
									setSelectedCategory(item)
									if (window.location.pathname.includes('products/')) {
										window.history.replaceState(null, null, `${item?.slug}`)
									} else {
										window.history.pushState(null, null, `products/${item?.slug}`)
									}
								}
							}}
						>
							{item?.name}
						</button>
					)
				})}
			</Col>
		</Row>
	)
}

export default Categories
